import { SENDER_TYPE, SenderType } from '@finance-lab/utils/types'
import { formatDateYYYYMMDD } from '../../../packages/utils/numberFormatters'
import { useQuery } from '../../../hooks/useQuery'
import { useMemo } from 'react'

export const PRESS_RELAESES_FILTER_PARAMS = {
    SEARCH: 'search',
    SENDER_TYPE: 'senderType',
    SHOW_ONLY_REPORTS: 'showOnlyReports',
    SHOW_ONLY_WITH_RELATED_TRANSACTIONS: 'showOnlyWithRelatedTransactions',
    END_DATE: 'endDate',
}

export const validateSenderType = (value: string | null): SenderType => {
    if (!value || !Object.values(SENDER_TYPE).indexOf(value as SenderType)) {
        return 'company'
    }

    return value as SenderType
}

export const validateEndDate = (value: string | null): string => {
    if (!value || isNaN(new Date(value).getTime())) {
        return formatDateYYYYMMDD(new Date(), true)
    }

    return value
}

export const useFilterSettings = () => {
    const query = useQuery()

    const result = useMemo(
        () => ({
            endDate: validateEndDate(query.get(PRESS_RELAESES_FILTER_PARAMS.END_DATE)),
            senderType: validateSenderType(query.get(PRESS_RELAESES_FILTER_PARAMS.SENDER_TYPE)),
            showOnlyReports: query.get(PRESS_RELAESES_FILTER_PARAMS.SHOW_ONLY_REPORTS) === 'true',
            showOnlyWithRelatedTransactions:
                query.get(PRESS_RELAESES_FILTER_PARAMS.SHOW_ONLY_WITH_RELATED_TRANSACTIONS) === 'true',
            searchValue: query.get(PRESS_RELAESES_FILTER_PARAMS.SEARCH) ?? undefined,
        }),
        [query],
    )

    return result
}
